import { getState } from './state';
export function getViewOptions(state) {
    var _getState;
    var _getState_viewOptions;
    return (_getState_viewOptions = (_getState = getState(state)) === null || _getState === void 0 ? void 0 : _getState.viewOptions) !== null && _getState_viewOptions !== void 0 ? _getState_viewOptions : {};
}
export function getIsCategoryFilterApplied(state) {
    var _getViewOptions_activeBucket;
    return ((_getViewOptions_activeBucket = getViewOptions(state).activeBucket) === null || _getViewOptions_activeBucket === void 0 ? void 0 : _getViewOptions_activeBucket.filterId) !== undefined;
}
export function getActiveFolder(state) {
    return getViewOptions(state).activeFolder;
}
export function getShowShortcuts(state) {
    return getViewOptions(state).showShortcuts;
}

//# sourceMappingURL=options.js.map